/** A tapped cashback badge stays expanded this long before auto-collapsing. */
export const CASHBACK_EXPAND_MS = 4000
/** The default (non-Luxe) cashback badge tone on Best Selling, the category grid, and the wishlist. */
export const CASHBACK_DEFAULT_BACKGROUND = '#FDC700'
/** Flash Deals' non-Luxe badge is a paler cream per Figma — sampled directly from the design (#FFF7D9), not the brighter gold used elsewhere. */
export const CASHBACK_FLASH_DEAL_DEFAULT_BACKGROUND = '#FFF7D9'
/** The Luxe cashback badge gradient is brand-consistent across every section. */
export const CASHBACK_LUXE_BACKGROUND =
  'linear-gradient(135deg, #FF9933 0%, #EBAD45 100%)'
/** Real per-product cashback can run to 5+ digits on high-ticket items, so this stays small enough to expand without clipping against the card edge or the rating chip. */
export const CATEGORY_CASHBACK_BADGE_SCALE = 0.8
/** Wishlist cards are narrower than a category card, but the badge still needs to read comfortably next to the rating chip, so it shrinks less than the category grid's. */
export const WISHLIST_CASHBACK_BADGE_SCALE = 0.8
/** The "View all upgrades for your car" grid is a similarly narrow 2-column card. */
export const CURATED_CASHBACK_BADGE_SCALE = 0.6
/**
 * PDP image overlay — matches the 31px-tall review chip on the product gallery
 * (`CashbackBadge` Figma base height is 20.57px).
 */
export const PDP_CASHBACK_BADGE_SCALE = 27 / 20.57
